<template>
  <div class="navBox">
      <div class="navTxt" @click="toHome">
        <div class="areaimg">
          <img :src="currentPath === '/index' ? require('@/assets/images/blind/news_on.png') : require('@/assets/images/blind/news.png')" alt="">
        </div>
        <div class="areatxt" :class="{ on: currentPath === '/index' }">看资讯</div>
      </div>
      <div class="navTxt" @click="toCate">
        <div class="areaimg">
          <img :src="(currentPath === '/cate') ? require('@/assets/images/blind/box_on.png') : require('@/assets/images/blind/box.png')" alt="">
        </div>
        <div class="areatxt" :class="{ on: currentPath === '/cate' }">开盲盒</div>
      </div>
      <div class="navTxt" @click="toMyPrize">
        <div class="areaimg">
          <img :src="currentPath === '/myprize' ? require('@/assets/images/blind/prize_on.png') : require('@/assets/images/blind/prize.png')" alt="">
        </div>
        <div class="areatxt" :class="{ on: currentPath === '/myprize' }">查奖品</div>
      </div>
    </div>
</template>

<script>
import jump2hbrb from '@/utils/jump2app-hb.js'

export default {
    name: 'navBar',
    data () {
        return {
          loading: true,
          lotteryid:0,
          token:"",
          accessid:'',
          openid:'' //微信用户openid
        }
    },
    computed: {
        currentPath () {
            return this.$route.path
        },
        accountId () {
            return this.$store.state.accountId
        },
        uniqueId () {
            return this.$store.state.uniqueId
        }
    },
    created () {
        this.token = this.$store.state.token;
    },
    methods: {
        toHome(){
            this.$router.push({ path: '/index',query:this.$route.query })
        },    
        toCate(){
          if(this.accountId && this.uniqueId) {
            this.$router.push({ path: '/cate',query:{...this.$route.query} })
          } else {            
            jump2hbrb.toMLink(window.location.href)
          }            
        },
        toMyPrize(){
          if(this.accountId && this.uniqueId) {
            this.$router.push({ path: '/myprize',query:this.$route.query })
          } else {
            jump2hbrb.toMLink(window.location.href)
          }               
        }
    }
}
</script>

<style lang="scss" scoped>
  .navBox{
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 80px;
    width: 600px;
    height: 100px;
    padding: 10px 0px;
    border-radius: 100px;
    background: #f9f9f9;
    border-top: 1px solid #c8c8c8;
    display: flex;
    justify-content: space-evenly;
    font-size: 30px;
    z-index: 1000;
    .navTxt{
      width: 140px;
      padding:0px 50px;
      height: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      color: #808080;
      font-weight: 400;
      .areaimg{
        width: 60px;
        height: 60px;
        img{
            width: 60px;
            height: 60px;
        }
      }
      .areatxt{
        width: 100%;
        height: 30px;
        line-height: 30px;
        font-size: 28px;
        text-align: center;
        margin-top: 5px;
      }
      .on{
        color: #e37638;
      }
    }
  } 
</style>